import { InBank } from '../components/InBank/InBank';
import { Avatar } from '../../../components/Avatar/Avatar';
import { LineSkin } from '../components/LineSkinContainer/LineSkin';
import { SliderClassic } from '../components/SliderClassic/SliderClassic';
import { Border } from '../../../components/Border/Border';
import './Game.css';

export const Game = () => {
    return (
        <div className="game__skins">
            <div className="game__skins-container">
                <SliderClassic />
                <Border />
                <InBank />
            </div>
            <div className="game__skins-chance-container">
                <div className="game__skins-avatar-team-container">
                    <span className="game__skins-avatar-team-text">gang gangsta 20.57%</span>
                    <div className="game__skins-avatar-container">
                        <Avatar />
                        <span className="game__skins-avatar-chance">42.85%</span>
                    </div>
                    <div className="game__skins-avatar-container">
                        <Avatar />
                        <span className="game__skins-avatar-chance">42.85%</span>
                    </div>
                </div>

                <div className="game__skins-avatar-container">
                    <Avatar />
                    <span className="game__skins-avatar-chance">42.85%</span>
                </div>
                <div className="game__skins-avatar-container">
                    <Avatar />
                    <span className="game__skins-avatar-chance">42.85%</span>
                </div>
                <div className="game__skins-avatar-container">
                    <Avatar />
                    <span className="game__skins-avatar-chance">42.85%</span>
                </div>
                <div className="game__skins-avatar-container">
                    <Avatar />
                    <span className="game__skins-avatar-chance">42.85%</span>
                </div>
                <div className="game__skins-avatar-container">
                    <Avatar />
                    <span className="game__skins-avatar-chance">42.85%</span>
                </div>
                <div className="game__skins-avatar-container">
                    <Avatar />
                    <span className="game__skins-avatar-chance">42.85%</span>
                </div>
                <div className="game__skins-avatar-container">
                    <Avatar />
                    <span className="game__skins-avatar-chance">42.85%</span>
                </div>
                <div className="game__skins-avatar-container">
                    <Avatar />
                    <span className="game__skins-avatar-chance">42.85%</span>
                </div>
            </div>
            <div className="game__skins-down-container">
                <LineSkin />
                <LineSkin />
                <LineSkin />
                <LineSkin />
                <LineSkin />
            </div>
        </div>
    );
};
